import {CustomerDocument} from '../../interfaces/customer-documents/customer-document';
import {CustomerDocumentType} from '../../interfaces/customer-documents/customer-document-type';
import {CustomerDocumentTypeFactory} from './customer-document-type-factory';
import {TkFile} from '../../interfaces/core/tk-file';
import {LightCustomer} from '../../interfaces/customers/light-customer';
import {LightCustomerFactory} from '../customers/light-customer-factory';

export class CustomerDocumentFactory {

  /**
   *
   * @param customerDocument
   */
  public static fromObject(customerDocument: any): CustomerDocument {
    return new class implements CustomerDocument {
      comment: string = customerDocument.comment;
      customerDocumentType: CustomerDocumentType =
        CustomerDocumentTypeFactory.fromObject(customerDocument.customer_document_type);
      customerDocumentTypeId: number = customerDocument.customer_document_id;
      date: string = customerDocument.date;
      title: string = customerDocument.title;
      file: TkFile = null;
      customer: LightCustomer = LightCustomerFactory.fromObject(customerDocument.customer);
      customerId: number = customerDocument.customer_id;

      // ---------------------------------------------------------------------------------------------------------------
      id: number = customerDocument.id;
      uuid: string = customerDocument.uuid;
      modified: string = customerDocument.modified;
      created: string = customerDocument.created;
      deleted: 0 | 1 = 0;
    };
  }

  /**
   *
   * @param customerDocuments
   */
  public static fromArray(customerDocuments: any[]): CustomerDocument[] {
    return customerDocuments.map(customerDocument => this.fromObject(customerDocument));
  }

  public static toRemote(customerDocument: CustomerDocument): any {
    return {
      comment: customerDocument.comment,
      customer_document_type_id: customerDocument.customerDocumentTypeId,
      date: customerDocument.date,
      title: customerDocument.title,
      customer_id: customerDocument.customerId,
      modified: customerDocument.modified,
      created: customerDocument.created
    };
  }

}